import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import App from './App.js';
import { queryClient } from './lib/queryClient.js';
import { useAuthStore } from './stores/authStore.js';
import { loadAndApplyTokens } from './services/uiSystem.service.js';
import './index.css';

// Load UI tokens on boot if authenticated
if (useAuthStore.getState().isAuthenticated) {
  void loadAndApplyTokens();
}
// Re-apply whenever auth state changes to authenticated
useAuthStore.subscribe((state, prev) => {
  if (state.isAuthenticated && !prev.isAuthenticated) {
    void loadAndApplyTokens();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
